import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ProgressiveCertificationsView from './ProgressiveCertificationsView';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import { getProgressiveCertifications } from '@/domain/useCases';
import constants from '@/core/constants';

const ProgressiveCertificationsController = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  // Get data from Redux store
  const progressiveCertificationsState = useSelector(
    (state: any) => state.progressiveCertifications
  );
  const profileState = useSelector((state: any) => state.profile);

  const { isLoading = false, data: certifications = [] } =
    progressiveCertificationsState || {};

  useEffect(() => {
    GoogleAnalytics.writeLog(
      'portal-course-progressiveCertifications',
      'course'
    );
    if (profileState?.data?.academic) {
      const { career, prog, plan } = profileState.data.academic;

      if (career && prog && plan) {
        dispatch(
          getProgressiveCertifications.Creators.getProgressiveCertifications(
            career,
            prog,
            plan
          )
        );
      }
    }
  }, [dispatch, profileState]);

  const handlerBack = () => history.push('/cursos');

  const handleDownload = async (certificateCode?: string) => {
    const profile = profileState?.data;
    const emplid = profile.profile.peopleCode;
    const career = profile.academic?.career;
    const codutpalu = profile.profile.studentCode;

    // Build download URL
    const baseUrl = constants.PE_URL_2;
    const downloadPath = constants.PE_PATH_IMPRIMIR;
    const downloadUrl = `${baseUrl}${downloadPath}?codigoCertificado=${certificateCode}&emplid=${emplid}&grado=${career}&codutpalu=${codutpalu}`;

    // Open download in new tab
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Track download event
    GoogleAnalytics.writeLog(
      'portal-course-progressiveCertifications-download',
      'course'
    );
  };

  return (
    <ProgressiveCertificationsView
      handlerBack={handlerBack}
      isLoading={isLoading}
      certifications={certifications}
      handleDownload={handleDownload}
    />
  );
};

export default ProgressiveCertificationsController;
